module.exports = "/_next/static/images/77fb24778025e8b7b087d7d80a7cf789-image-right.jpg";